import ContactForm from "./contact-form";
import Email from "../shared/email";
import {
  getEntityLabel,
  getTitleBase,
  validate2AgentTeam,
  getCorrectOffSalesRegion,
} from "../shared/util";
import Helmet from "react-helmet";
import IntroText from "./intro-text";
import Phones from "./phones";
import PropTypes from "prop-types";
import React, { Component } from "react";
import _ from "lodash";
import "./contact.scss";
import TeamPhone from "../shared/team-phone";
class Contact extends Component {
  render() {
    const entity = this.props.entity;
    const title = `Contact - ${getTitleBase(entity)}`;
    let teamAgentOffice = [];
    if (this.props.entity.teamMembers) {
      this.props.entity.teamMembers.forEach((element) => {
        const agentOffice = {
          officeName: element.officeDetails.Name,
          address1: element.officeDetails.Address1,
          address2: element.officeDetails.Address2,
          town: element.officeDetails.PostalTown,
          state: element.officeDetails.State,
          zip: element.officeDetails.PostalCode,
        };
        if (teamAgentOffice.length > 0) {
          const isFound = teamAgentOffice.some((element) => {
            if (element.officeName === agentOffice.officeName) {
              return true;
            }
            return false;
          });
          if (!isFound) {
            teamAgentOffice.push(agentOffice);
          }
        } else {
          teamAgentOffice.push(agentOffice);
        }
      });
    } else {
      const agentOffice = {
        officeName: entity.office.name,
        address1: entity.office.address1,
        address2: entity.office.address2,
        town: entity.office.town,
        state: entity.office.state,
        zip: entity.office.zip,
      };
      teamAgentOffice.push(agentOffice);
    }
    return (
      <div className="contact-page web-container container">
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content={`Ready to start your home search or place your home on the market? Contact ${
              entity.displayName
            } ${getCorrectOffSalesRegion(entity)} real estate ${getEntityLabel(
              entity
            ).toLowerCase()} of ${entity.brand}, Inc.`}
          />
        </Helmet>
        <div className="page-header">
          <h1>Contact</h1>
          <div className="header-separator"></div>
        </div>
        <IntroText
          contactPageCustomText={entity.siteOptions.contactPageCustomText}
        />
        <div className="row">
          <div className="col-xs-6 col-xxs-16 agent-info">
            {entity.hasPhoto ? (
              <div>
                <img src={entity.photo.url} alt={entity.displayName} />
              </div>
            ) : null}
            <div className="contact-info">
              <h2>{entity.displayName}</h2>
              <span className="line-item italic">{entity.title}</span>
              <span className="line-item">{entity.license}</span>
              {entity && validate2AgentTeam(entity) ? (
                <TeamPhone
                  classes="line-item"
                  entity={entity}
                  prefix="Tel"
                  separator={false}
                />
              ) : (
                <Phones entity={entity} />
              )}
              <Email email={entity.emailAddress} classes="line-item" />
            </div>
            <div className="contact-info">
              {/* atlasOfficeId 157 */}
              {entity.officeId !== "c0c006f4-5237-4565-b90e-8411c757b966" ? (
                <span className="line-item company">{entity.brand}</span>
              ) : (
                ""
              )}
              {teamAgentOffice && teamAgentOffice.length === 1 ? (
                <span>
                  <span className="line-item office-name italic">
                    {entity.office.name}
                  </span>
                  <span className="line-item">
                    {entity.office.address1} {entity.office.address2}
                  </span>
                  <span className="line-item">
                    {entity.office.town}, {entity.office.state}{" "}
                    {entity.office.zip}
                  </span>
                </span>
              ) : (
                _.orderBy(teamAgentOffice, ["officeName"], ["asc"]).map(
                  (data) => {
                    return (
                      <span>
                        <span className="line-item office-name italic">
                          {data.officeName}
                        </span>
                        <span className="line-item">
                          {data.address1} {data.address2}
                        </span>
                        <span className="line-item team-last">
                          {data.town}, {data.state} {data.zip}
                        </span>
                      </span>
                    );
                  }
                )
              )}
            </div>
          </div>
          <div className="col-xs-10 col-xxs-16">
            <ContactForm emailAddress={entity.emailAddress} />
          </div>
        </div>
        <div style={{ height: "150px" }}></div>
      </div>
    );
  }
}

PropTypes.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/contact/contact.js